import { SVG, getDefaultHeight } from "./utils";

type Props = {
  color?: string;
} & React.SVGProps<SVGSVGElement>;

export const BulbIcon: React.FC<Props> = ({
  color = "currentColor",
  ...svgProps
}) => {
  return (
    <SVG
      xmlns="http://www.w3.org/2000/svg"
      height={getDefaultHeight(svgProps, 24)}
      viewBox="0 0 22.5 24"
      {...svgProps}
    >
      <g
        fill="none"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      >
        <path d="M14.25 17.25v2.25a1.5 1.5 0 01-1.5 1.5h-3a1.5 1.5 0 01-1.5-1.5v-2.25" />
        <path d="M11.25.75v1.5" />
        <path d="M.75 11.25h1.5" />
        <path d="M3 3.75l1.1 1.057" />
        <path d="M21.75 11.25h-1.5" />
        <path d="M19.5 3.75l-1.1 1.057" />
        <path d="M8.165 17.25h6.17a6.6 6.6 0 003.665-6 6.873 6.873 0 00-6.75-6.75 6.873 6.873 0 00-6.75 6.754 6.6 6.6 0 003.665 6z" />
        <path d="M11.25 21v2.25" />
        <path d="M11.25 13.5v3.75" />
        <path d="M9 11.25l2.25 2.25 2.25-2.25" />
      </g>
    </SVG>
  );
};
